<template>
  <div id="app">
    <router-view v-wechat-title="$route.meta.title" />
  </div>
</template>

<script>
export default {
  name: "App",

  mounted() {
document.body.style.height ='100px'
  },
};
</script>

<style lang="less">
@import "./style.less";
#app {
  height: 100%;

}
html {
  height: 100%;
  background: #fff;
    min-width: 1200px;
}
body {
  height: 100%;
  background: #fff;
}
* {
  margin: 0;
  padding: 0;
}
br {
    content: "";
  margin: 2em;
  display: block;
  font-size: 24%;
}
	@font-face {
  font-family: font_substitution;
}


body {
  font-family: font_substitution;  
}
</style>



// WEBPACK FOOTER //
// src/App.vue